import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'EN', name: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'ES', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'PT', name: 'Português', flag: '🇧🇷' }
];

export const LANGUAGE_STORAGE_KEY = 'soroswap-language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt }
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((language) => language.code),
    // Maps regional device locales (es-CL, pt-BR, en-GB) onto our base languages.
    load: 'languageOnly',
    detection: {
      // A saved choice always wins over the device language.
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage']
    },
    interpolation: {
      // React already escapes rendered values.
      escapeValue: false
    },
    react: {
      // Every locale is bundled up front, so there is nothing to await.
      useSuspense: false
    },
    returnEmptyString: false
  });

// Keeps <html lang> in sync for screen readers and SEO crawlers.
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

document.documentElement.lang = i18n.resolvedLanguage || 'en';

export default i18n;
